// eslint-disable
import Dexie, { EntityTable } from 'dexie';

// import { getTargets } from '@/generated/client/targets/targets';
import { MinimalTarget, MinimalUser } from '@/generated/model';

// const CACHE_TTL_HOURS = 24;
// const CACHE_TTL_MILLISEC = CACHE_TTL_HOURS * 3600000; // 86,400,000

type TargetInDb = MinimalTarget & {
  normalizedName: string;
};

let _localCacheFilled: boolean = false;

export function localCacheFilled() {
  return _localCacheFilled;
}

export const db = new Dexie('VehicleCache') as Dexie & {
  vehicle: EntityTable<TargetInDb, 'id'>;
};

db.version(1).stores({
  vehicle: '&id, normalizedName, name, description, category, state, comment, customerName',
});

export function norm(s: string) {
  return s.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
}

async function dropDb() {
  _localCacheFilled = false;
  await db.delete({
    disableAutoOpen: false,
  });
  localStorage.removeItem('cachedTargetsTimestamp');
  localStorage.removeItem('userCachedFor');
}
/*
async function okDb(user: MinimalUser) {
  _localCacheFilled = true;
  const count = await db.vehicle.count();
  localStorage.setItem('cachedTargetsTimestamp', Date.now().toString());
  localStorage.setItem('userCachedFor', user.id.toString());
  localStorage.setItem('vehicleCount', count.toString());
}
*/

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function initDb(_user: MinimalUser /*, pagesize: number = 1000*/): Promise<void> {
  // disable local caching
  await dropDb();
  return;
  /*
  await db.open();
  // token usernel 1 target van, nem cache-elunk
  if (user.isTokenUser) {
    console.debug('token user');
    await dropDb();
    return;
  }

  const count = await db.vehicle.count();
  const localStorageCount = localStorage.getItem('vehicleCount');

  if (localStorageCount && count.toString() !== localStorageCount) {
    await dropDb();
  }

  // ha nem az az user aki a cache-hez tartozik akkor eldobjuk es uj cache
  const cacheUser = localStorage.getItem('userCachedFor');
  if (cacheUser && user.id.toString() !== cacheUser) {
    console.debug('wrong user', user.id.toString(), localStorage.getItem('userCachedFor'));
    await dropDb();
    // alabb ujra fogja inicializalni mar az uj userre
  }

  // ervenyes-e meg a cache
  const t = localStorage.getItem('cachedTargetsTimestamp');
  if (t) {
    const d = new Date(parseInt(t, 10));
    const now = new Date();
    const diff = now.getTime() - d.getTime();
    if (diff > CACHE_TTL_MILLISEC) {
      // cache invalid
      console.debug('cache expired #1');
      initDbImpl(user, pagesize);
    } else {
      _localCacheFilled = true;
      // beutemezzuk a frissitest
      const when = CACHE_TTL_MILLISEC - diff;
      console.debug(`refresh in ${when} ms`);
      setTimeout(() => {
        console.debug('cache expired #2, refreshing');
        initDbImpl(user, pagesize);
      }, when);
    }
  } else {
    initDbImpl(user, pagesize);
  }
*/
}
/*
async function initDbImpl(user: MinimalUser, pagesize: number): Promise<void> {
  console.debug('initdbImpl');
  // cache toltes/update idejen nem hasznalhato
  await dropDb();

  let offset = 0;
  let keepLoading = true;
  const order = 'asc';

  while (keepLoading) {
    try {
      const targets = await getTargets({
        filter: undefined,
        offset: offset,
        limit: pagesize,
        order: order,
      });

      const data = targets.data;

      if (data && data.length > 0) {
        const data1 = data.map((d) => ({
          ...d,
          normalizedName: norm(d.name),
        }));

        try {
          await db.vehicle.bulkPut(data1);
        } catch (_e) {
          if (_e instanceof Dexie.BulkError) {
            console.warn('Some records failed to insert:', _e.failures); // shows which ones
          }
        }
      }

      if (data && data.length < pagesize) {
        // Last page, stop loading
        keepLoading = false;
      } else {
        // More pages to load
        offset += pagesize;
        // await delay();
      }
    } catch (error) {
      console.error('Error loading or inserting data:', error);
      keepLoading = false;
      return;
    }
  }
  await okDb(user);
}
*/
